<!-- .block-product-columns -->
<div class="block block-product-columns d-lg-block d-none">
    <div class="container">
        <div class="row">
            <ng-content select="app-block-product-columns-item"></ng-content>
        </div>
    </div>
</div>
<!-- .block-product-columns / end -->
